/*
 *   Copyright (c) 2021 Sok Channy
 *   All rights reserved.
 */
// Copyright 2021 channysok
// 
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// 
//     http://www.apache.org/licenses/LICENSE-2.0
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and

import StatisticAction from "../action/StatisticAction"

// limitations under the License.
StatisticAction
export const initialState = ({    
    userStatisticList: undefined,
    waybillStatisticList: undefined,
    wallet: null,
})
  
export default function (state = initialState, action) {
    switch (action.type) {
  
      case StatisticAction.TYPES.REQUEST_USER_STATISTIC_LIST_SUCCESS:
        return Object.assign({}, state, { userStatisticList: action.payload })

      case StatisticAction.TYPES.REQUEST_WAYBILL_STATISTIC_LIST_SUCCESS:
        return Object.assign({}, state, { waybillStatisticList: action.payload })

      case StatisticAction.TYPES.REQUEST_WALLET_DETAIL_SUCCESS:
        return Object.assign({}, state, { wallet: action.payload.data, loading: false})
              
      default:
        return state
    }
}



  